import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { RootState } from "reducers";
import { IRequisition } from "./domain/IRequisition";

export const deleteRequisition = createAsyncThunk(
  "Requisitions/deleteRequisition",
  async (requisitionId: number) => {
    try {
      return console.log(requisitionId);
      // return await requisitionsService.deleteRequisition(requisitionId);
    } catch (err) {
      setError(err);
    }
  }
)

interface requisitionState {
  loading: boolean;
  requisitions: IRequisition[];
  deleteRequisitionModalOpen: boolean;
  requisitionForDeletion: number;
  error: any;
}

const initialState: requisitionState = {
  loading: false,
  requisitions: [],
  deleteRequisitionModalOpen: false,
  requisitionForDeletion: -1,
  error: null
}

export const requisitionSlice = createSlice({
  name: "requisition",
  initialState: initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setDeleteRequisitionModalOpen: (
      state,
      action: PayloadAction<{ visible: boolean; index: number }>) => {
      state.deleteRequisitionModalOpen = action.payload.visible;
      state.requisitionForDeletion = action.payload.index;
    },
    updateRequisition: (state, action: PayloadAction<IRequisition>) => {
      let index = state.requisitions.findIndex(requisition =>
        requisition.requisitionId === action.payload.requisitionId);

      state.requisitions[index] = action.payload;
    },
    acceptRequisitionById: (state, action: PayloadAction<IRequisition>) => {
      if (action.payload) {
        let index = state.requisitions.findIndex(requisition =>
          requisition.requisitionId === action.payload.requisitionId);

        state.requisitions[index] = action.payload;
      }
    },
    deleteRequisitionById: (state, action: PayloadAction<number>) => {
      if (action.payload) {
        state.requisitions = state.requisitions.filter(requisition =>
          requisition.requisitionId !== action.payload
        );
      }
    },
    setError: (state, action: PayloadAction<any>) => {
      state.error = action.payload;
    }
  },
  extraReducers: (builder) => {
  },
});

export const selectState = (state: RootState) => state.requisition;
export const selectRequisitionForDeletion = (state: RootState) =>
  state.requisition.requisitions[state.requisition.requisitionForDeletion];

export const {
  setLoading,
  updateRequisition,
  acceptRequisitionById,
  setDeleteRequisitionModalOpen,
  deleteRequisitionById,
  setError
} = requisitionSlice.actions;

export default requisitionSlice.reducer;
